<script lang="ts" setup>
    import IdMeMfa from '../IdMeVerify/IdMeMfa.vue'
    import _ from 'lodash';
    import { computed, reactive, onMounted, } from 'vue';
    import { ChoiceApi, LoadingSection } from '../../LibMain';
    import { popAlert } from '../../lib/Notification';
    import { DisplayStyle, TextDisplayStyle } from '../../Enums/UiEnums';
    import { ActionButtonStyle } from '../../lib/Types/Types';
    import MessageSection from "../../components/Messages/MessageSection.vue"
    import MessageText from "../../components/Messages/MessageText.vue" 
    import ActionButtonV2 from '../../components/ActionButtonV2.vue';
    import { closeModal } from '../../lib/Legacy/ModalWindow';
   
    enum StepTypes
    {
        showCredentialInfo,
        showMfa
    }
 
    const compData = reactive<{
        step?: StepTypes,
        approvalRequest : {credentialID : number, enabledFlag : string}
    }>({
        step: StepTypes.showCredentialInfo,
        approvalRequest : {credentialID : 0, enabledFlag : "N"}
    });
    
    const props = defineProps<{
        credentialType: string,
        credentialDetails: string,
        issuerCn: string,
        certSerialNumber: string,
        enabledFlag: string,
        credentialId: number
    }>(); 
    const htmlString = computed(()=>{
        return props.credentialDetails
    });
    const signatureMessage = "By completing the two-factor authentication at this time, you are approving the registration of this credential/certificate for digitally signing."
    
    onMounted(async () =>{ 
        compData.approvalRequest = {credentialID : props.credentialId, enabledFlag : props.enabledFlag};
    });
    async function onClickAgreeButton()
    {
        compData.step = StepTypes.showMfa;
    }

    async function onClickDeclineButton()
    {
        closeModal(true); 
    }   
    
    async function onMfaSuccess()
    {
        const newSigMessage = signatureMessage + props.credentialDetails;  
        const respApproval = await ChoiceApi.signature.approveForIdMe(compData.approvalRequest.credentialID, compData.approvalRequest.enabledFlag, newSigMessage, (errMsg) => {
            popAlert(`Error approving credential: ${errMsg}`);
            compData.step = StepTypes.showCredentialInfo;
        }); 
        if (!respApproval)
            return;
            
        if (!respApproval.isSuccess) {
            await popAlert(respApproval.errorMsg ?? "Unable to approve credential.");
            compData.step = StepTypes.showCredentialInfo;
            return;          
        }
        closeModal(true, undefined, { legacyReturnValue: respApproval.signedMsg });
    }
    async function onMfaFailure(errorMsg?: string)
    {
        if (errorMsg)
            await popAlert(`MFA failure: ${errorMsg}`);

        compData.step = StepTypes.showCredentialInfo;
    }
</script>
<template> 
    <div v-if="StepTypes.showCredentialInfo === compData.step">
        <div v-html="htmlString"></div>  
        <hr/>
        <MessageText :displayStyle="TextDisplayStyle.Muted">
            {{ signatureMessage }}
        </MessageText>
        
        <div class="mt-2">
            <span class="me-2">
                <ActionButtonV2 :action="ActionButtonStyle.Save" :performAction="onClickAgreeButton" text="I Agree" />
            </span>
            <ActionButtonV2 :action="ActionButtonStyle.Save" :performAction="onClickDeclineButton" text="I Decline" :displayStyle="DisplayStyle.Danger" />
        </div> 
    </div> 
    <div v-if="StepTypes.showMfa === compData.step" >
        <div>
            <strong>
                Multi-Factor Authentication Options
            </strong>
        </div>
        <IdMeMfa @mfaSuccess="onMfaSuccess" @mfaFailure="onMfaFailure" />
    </div> 
</template>